import mockExcesses from '@/mocks/get-excesses.json';
import mockAvProducts from '@/mocks/get-products-av.json';
import mockHvProducts from '@/mocks/get-products-hv.json';
import mockTvProducts from '@/mocks/get-products-tv.json';
import type { AppContext } from '@/types';
import type { FetchExcessesData, ProductsResponse } from '@/types/product';
import { getRequest } from '@/utils/api';
import type { Nullable } from 'design.zorgdomein/dist/typings/types/generics';

export const fetchProducts = async (appContext: AppContext, language: string, type?: string) => {
    try {
        const { body } = await getRequest<ProductsResponse>({
            appContext,
            endpoint: '/getproducts',
            language,
            params: type ? { productType: type } : undefined
        });

        return body;
    } catch (error) {
        console.error('Cannot fetch products:', { error });

        return null;
    }
};

export const fetchSpecificProducts = async (
    appContext: AppContext,
    language: string,
    pageEditing: boolean,
    group?: string,
    mock?: ProductsResponse
): Promise<Nullable<ProductsResponse>> => {
    if (pageEditing) {
        return mock as unknown as ProductsResponse;
    }

    const data = await fetchProducts(appContext, language, group);

    if (data && data.products && data.productGroups) {
        return data;
    }

    return null;
};

export const fetchBasicProducts = async (
    appContext: AppContext,
    language: string,
    pageEditing: boolean
) => await fetchSpecificProducts(appContext, language, pageEditing, 'hv', mockHvProducts);

export const fetchAdditionalProducts = async (
    appContext: AppContext,
    language: string,
    pageEditing: boolean
) => await fetchSpecificProducts(appContext, language, pageEditing, 'av', mockAvProducts);

export const fetchDentalProducts = async (
    appContext: AppContext,
    language: string,
    pageEditing: boolean
) => await fetchSpecificProducts(appContext, language, pageEditing, 'tv', mockTvProducts);

export const fetchExcesses = async (
    appContext: AppContext,
    language: string,
    pageEditing: boolean
) => {
    try {
        if (pageEditing) {
            return mockExcesses;
        }

        const { body } = await getRequest<FetchExcessesData>({
            appContext,
            endpoint: '/getexcesses',
            language
        });

        if (body.excesses && body.excesses.length) {
            return body;
        } else {
            throw Error('Invalid data for excesses received');
        }
    } catch (error) {
        console.error('Cannot fetch excesses:', { error });

        return null;
    }
};
